import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useOrganization } from '../context/OrganizationContext';
import { LanguageToggle, useLanguage } from '../context/LanguageContext';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { organization } = useOrganization();
  const { isAuthenticated, isAdmin, logout } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  const closeMenu = () => setIsMenuOpen(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
    closeMenu();
  };

  const toggleMenu = () => {
    setIsMenuOpen((open) => !open);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-brand" onClick={closeMenu}>
            {organization?.logo ? (
              <img src={organization.logo} alt={organization.chinese_name || organization.name} className="navbar-logo" />
            ) : (
              <span className="navbar-brand-text">
                {organization?.chinese_name || organization?.english_name || 'Hong Kong Synergies'}
              </span>
            )}
          </Link>

          <button
            type="button"
            className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? t('nav.closeMenu') : t('nav.openMenu')}
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {isMenuOpen && (
            <button
              type="button"
              className="navbar-overlay"
              aria-label={t('nav.closeMenu')}
              onClick={closeMenu}
            />
          )}

          <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
            <Link to="/" onClick={closeMenu}>{t('nav.home')}</Link>
            <Link to="/about" onClick={closeMenu}>{t('nav.about')}</Link>
            <Link to="/services" onClick={closeMenu}>{t('nav.services')}</Link>
            <Link to="/organization-structure" onClick={closeMenu}>{t('nav.org')}</Link>
            <Link to="/blog" onClick={closeMenu}>{t('nav.news')}</Link>
            <Link to="/contact" onClick={closeMenu}>{t('nav.contact')}</Link>
            <LanguageToggle />

            {isAuthenticated() ? (
              <>
                {isAdmin() ? (
                  <Link to="/admin" className="btn-nav" onClick={closeMenu}>
                    {t('nav.admin')}
                  </Link>
                ) : (
                  <Link to="/member" className="btn-nav" onClick={closeMenu}>
                    {t('nav.member')}
                  </Link>
                )}
                <button type="button" onClick={handleLogout} className="btn-nav btn-logout">
                  {t('nav.logout')}
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn-nav" onClick={closeMenu}>
                  {t('nav.login')}
                </Link>
                <Link to="/register" className="btn-nav btn-primary" onClick={closeMenu}>
                  {t('nav.join')}
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
